export default [
  {
    id: 1,
    label: 'Slumber Bar',
    param: 'slumber',
    paramId: 51
  },
  {
    id: 2,
    label: 'Scrub A Dub Dub',
    param: 'scrub',
    paramId: 57
  },
  {
    id: 3,
    label: 'Sun Soothers',
    param: 'sun',
    paramId: 79
  },
  {
    id: 4,
    label: 'Quench Bar',
    param: 'quench',
    paramId: 58
  },
  {
    id: 5,
    label: 'Dads & Dudes',
    param: 'dads',
    paramId: 80
  },
  {
    id: 6,
    label: 'Bling Bar',
    param: 'bling',
    paramId: 59
  },
  {
    id: 7,
    label: 'View All',
    param: 'all',
    paramId: null
  }
];
